<template>
  <div class="modal-shadow">
    <div class="modal" :style="styles">
      <slot />
      <button type="button" class="close-button" @click="close">X</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'client-modal',

  props: {
    width: {
      type: String,
      default: 'auto',
    },
    height: {
      type: String,
      default: 'auto',
    },
  },

  computed: {
    styles() {
      return {
        '--width': this.width,
        '--height': this.height,
      };
    },
  },

  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.modal-shadow {
  position: fixed;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;

  background-color: rgba(14, 14, 14, 0.44);
}
.modal {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  max-height: 92%;
  width: var(--width);
  height: var(--height);

  padding: 43px 60px 33px 60px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background: #ffffff;
  border: 4px solid #8dc54e;
  border-radius: 18px;
}
.close-button {
  position: absolute;
  top: 13px;
  right: 13px;
  height: 2em;
  width: 2em;

  color: white;
  font-size: 15px;

  background-color: #8dc54e;
  border: none;
  border-radius: 50%;

  cursor: pointer;
}
</style>
